import {
    faFileInvoiceDollar,
    faFileExport,
    faCalendarAlt,
    faPlusCircle,
    faMinusCircle,
    faSync,
    faMapMarkerAlt,
    faFileImport,
    faRoute,
    faUndo,
    faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';

export const SupportTools = [
    {
        id: 'reject-billing-payroll',
        name: 'Reject Billing & Payroll',
        description: 'Remove billing and payroll data from a timesheet so it can be re-processed.',
        icon: faFileInvoiceDollar,
        category: 'Billing',
        useCases: [
            'Timesheet was approved with incorrect hours',
            'Need to recalculate billing after rate change',
            'Payroll was processed with wrong employee assignment',
        ],
    },
    {
        id: 'move-timesheet-to-contract',
        name: 'Move Timesheet to Contract',
        description: 'Transfer one or more timesheets to a different contract, optionally adding or replacing charges.',
        icon: faFileExport,
        category: 'Timesheet',
        useCases: [
            'Timesheet was created under the wrong contract',
            'Customer requested billing under a different contract',
            'Need to consolidate work under a master contract',
        ],
    },
    {
        id: 'merge-project',
        name: 'Merge or Move Project',
        description: 'Move all non-invoiced jobs from the source project to the destination project. If the source project contains no remaining jobs, it will be deleted.',
        icon: faFileExport,
        category: 'Project',
        useCases: [ ],
    },
    {
        id: 'change-job-date-time',
        name: 'Change Job Date / Start Time',
        description: 'Move a timesheet to a different date or update its start time. The date must be after the last invoiced date for the project.',
        icon: faCalendarAlt,
        category: 'Timesheet',
        useCases: [
            'Timesheet was created on the wrong date',
            'Work was performed on a different day than recorded',
            'Need to correct the start time on a timesheet',
        ],
    },
    {
        id: 'add-charges-to-timesheet',
        name: 'Add Charges to Timesheet',
        description: 'Add or replace charge types on one or more timesheets.',
        icon: faPlusCircle,
        category: 'Timesheet',
        useCases: [
            'A surcharge needs to be added based on an existing charge type',
            'An incorrect charge type needs to be replaced with the correct one',
            'Multiple timesheets need the same charge applied at once',
        ],
    },
    {
        id: 'remove-charges',
        name: 'Remove Charges from Timesheet',
        description: 'Remove one or more charge types from a timesheet.',
        icon: faMinusCircle,
        category: 'Timesheet',
        useCases: [
            'An incorrect charge type was added to a timesheet',
            'Standby or other charges need to be removed before billing',
            'Multiple incorrect charges were added during data entry',
        ],
    },
    {
        id: 'sync-timesheet-contract-billing',
        name: 'Sync Timesheet/Contract Billing',
        description: "Synchronize a timesheet's billing state with its contract settings, or force it into billing.",
        icon: faSync,
        category: 'Billing',
        useCases: [
            'Timesheet is not appearing in the billing queue after approval',
            'Billing state is out of sync with the contract settings',
            'Need to force a timesheet into billing or billing: charges',
        ],
    },
    {
        id: 'add-job-city',
        name: 'Add New Job City',
        description: 'Add a new city to the system so it can be selected when creating jobs.',
        icon: faMapMarkerAlt,
        category: 'Setup',
        useCases: [
            "A dispatcher cannot find the customer's city in the job setup form",
            'A new service area has been added and the city is not in the system',
        ],
    },
    {
        id: 'crew-eta-test-drive',
        name: 'Crew ETA Test Drive',
        description: 'Create a simulated crew drive so the customer-portal crew ETA (chip, route line, live movement) can be exercised or demonstrated without a real GPS-tracked truck. Available everywhere — but it creates REAL job/timesheet data, so never run it in a production environment.',
        icon: faRoute,
        category: 'Setup',
        useCases: [
            'QA needs to run the crew ETA functional script without waiting for a live job',
            'Sales wants to demo the Uber-style crew tracking to a prospect',
            'A developer needs live crew movement against a local or dev environment',
        ],
    },
    {
        id: 'import-customer-data',
        name: 'Import Customer Data',
        description: 'Import records (customers, employees, equipment, charge types, and more) into a tenant from a CSV file.',
        icon: faFileImport,
        category: 'Setup',
        useCases: [
            'Onboarding a new tenant that needs its customers, employees, or equipment loaded in bulk',
            'A customer provided a spreadsheet of records to be added to the system',
            'Backfilling reference data (charge types, positions, vehicles, inventory) for a tenant',
        ],
    },
    {
        id: 'rollback-payroll-export',
        name: 'Rollback Payroll Export',
        description: 'Undo a payroll export for selected offices and employees, returning their payroll records to Processed status.',
        icon: faUndo,
        category: 'Payroll',
        useCases: [
            'An office was exported by accident and needs to be recalculated',
            'A single employee needs to be pulled out of an export and reprocessed',
            'Payroll was exported before a correction was made and needs to be undone',
        ],
    },
    {
        id: 'test-messaging',
        name: 'Test SMS & Email',
        description: "Send a one-line test text or email through this web app's Twilio and SendGrid configuration.",
        icon: faPaperPlane,
        category: 'Setup',
        useCases: [
            'Prove outbound messaging works on a newly stood-up environment before go-live',
            'Check the from-number and from-address employees will see',
            'Read the provider error text when texts or emails stop arriving',
        ],
    },
];


export const getSupportTool = (id) => SupportTools.find((tool) => tool.id === id) ?? null;
